import { SvgIcon } from '@mui/material';

const ArrowRightSmall = (props) => {
  return (
    <SvgIcon width="8" height="14" viewBox="0 0 8 14" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M7.80474 7.47518C8.06443 7.21252 8.06443 6.78816 7.80474 6.52482L1.64142 0.285008C1.26654 -0.0950026 0.656596 -0.0950026 0.281043 0.285008C-0.0938435 0.665018 -0.0938435 1.28177 0.281043 1.66178L5.55343 7.00034L0.281043 12.3375C-0.0938435 12.7182 -0.0938435 13.335 0.281043 13.715C0.656596 14.095 1.26654 14.095 1.64142 13.715L7.80474 7.47518Z"/>
    </SvgIcon>
  );
};

export default ArrowRightSmall;